import { useState, type ComponentProps } from 'react';

interface PasswordInputProps extends Omit<ComponentProps<'input'>, 'type'> {
  label: string;
  hint?: string;
  error?: string | null;
}

export function PasswordInput({ label, hint, error, ...rest }: PasswordInputProps) {
  const [show, setShow] = useState(false);

  return (
    <div>
      <label
        htmlFor={rest.id}
        className="block font-mono text-[10px] uppercase tracking-[0.18em] text-[var(--ink-tertiary)]"
      >
        {label}
      </label>
      <div className="mt-2 flex gap-2">
        <input
          {...rest}
          type={show ? 'text' : 'password'}
          autoComplete={rest.autoComplete ?? 'current-password'}
          spellCheck={false}
          className="w-full rounded-sm border border-[var(--border-default)] bg-[var(--bg-paper)] px-3 py-2 font-mono text-sm text-[var(--ink-primary)] focus:border-[var(--accent-saffron)] focus:outline-none"
        />
        <button
          type="button"
          onClick={() => setShow((v) => !v)}
          className="rounded-sm border border-[var(--border-default)] px-3 py-2 font-sans text-xs text-[var(--ink-secondary)] hover:border-[var(--border-strong)]"
        >
          {show ? 'Ocultar' : 'Mostrar'}
        </button>
      </div>
      {hint && !error && (
        <p className="mt-1.5 font-sans text-xs text-[var(--ink-tertiary)]">{hint}</p>
      )}
      {error && (
        <p className="mt-1.5 font-sans text-xs text-[var(--accent-crimson)]">{error}</p>
      )}
    </div>
  );
}
